// @ts-nocheck
import 'react-date-range/dist/styles.css' // main css file
import 'react-date-range/dist/theme/default.css' // theme css file
import {useEffect, useState, useCallback, useMemo} from 'react'
import {MenuComponent} from '../../../../../../_metronic/assets/ts/components'

import {KTSVG} from '../../../../../../_metronic/helpers'
import {useQueryRequest} from '../../core/QueryRequestProvider'
const UsersListFilter = ({
  page,
  setPage,
  sDate,
  eDate,
  setSDate,
  setEDate,
  genderFilter,
  setGenderFilter,
  loading,
  setLoading,
  applyFilter,
  setApplyFilter,
}) => {
  const [startDate, setStartDate] = useState(sDate)

  const [endDate, setEndDate] = useState(eDate)

  const [gender, setGender] = useState(genderFilter)

  const {updateState} = useQueryRequest()
  const [role, setRole] = useState<string | undefined>()
  const [lastLogin, setLastLogin] = useState<string | undefined>()

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const resetData = useCallback(() => {
    // updateState({filter: undefined, ...initialQueryState})
    setGenderFilter('')
    setSDate('')
    setEDate('')
    setPage(1)
  }, [setGenderFilter, setSDate, setEDate, setPage])

  const filterData = useCallback(() => {
    // updateState({
    //   filter: {role, last_login: lastLogin},
    //   ...initialQueryState,
    // }),
    // setGenderFilter('')
    // setSDate('')
    // setEDate('')
    // setPage(1)

    setLoading(true)
    setApplyFilter(true)
  }, [setLoading, setApplyFilter])

  // Memoize the max date to prevent unnecessary recalculations
  const maxDate = useMemo(() => new Date().toISOString().split('T')[0], [])

  return (
    <>
      {/* begin::Filter Button */}
      <button
        // disabled={false}
        type='button'
        className='btn btn-light-primary me-3'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
      >
        <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-2' />
        Filter
      </button>

      {/* end::Filter Button */}
      {/* begin::SubMenu */}
      <div className='menu menu-sub menu-sub-dropdown w-300px w-md-325px' data-kt-menu='true'>
        {/* begin::Header */}
        <div className='px-7 py-2'>
          <div className='fs-6 text-dark fw-bolder'>Filter Options</div>
        </div>
        {/* end::Header */}

        {/* begin::Separator */}
        <div className='separator border-gray-200'></div>
        {/* end::Separator */}

        {/* begin::Content */}
        <div className='px-7 py-1' data-kt-user-table-filter='form'>
          {/* begin::Input group */}
          {/* <div>
            <label className='form-label fs-6 fw-bold'>Gender:</label>
            <select
              className='form-select form-select-solid fw-bolder'
              data-kt-select2='true'
              data-placeholder='Select option'
              data-allow-clear='true'
              data-kt-user-table-filter='role'
              data-hide-search='true'
              onChange={(e) => setGenderFilter(e.target.value)}
              value={genderFilter}
            >
              <option value=''></option>
              <option value='male'>Male</option>
              <option value='female'>Female</option>
              <option value=''>Prefer not to say</option>
            </select>
          </div> */}

          {/* <div>
            <label className='form-label fs-6 fw-bold'>Location:</label>
            <select
              className='form-select form-select-solid fw-bolder'
              data-kt-select2='true'
              data-placeholder='Select option'
              data-allow-clear='true'
              data-kt-user-table-filter='role'
              data-hide-search='true'
              onChange={(e) => setGender(e.target.value)}
              value={gender}
            >
              <option value=''></option>
              <option value='male'>Male</option>
              <option value='female'>Female</option>
              <option value='Prefer not to say'>Prefer not to say</option>
            </select>
          </div> */}

          {/* <div>
            <label className='form-label fs-6 fw-bold'>Subscription Type:</label>
            <select
              className='form-select form-select-solid fw-bolder'
              data-kt-select2='true'
              data-placeholder='Select option'
              data-allow-clear='true'
              data-kt-user-table-filter='role'
              data-hide-search='true'
              onChange={(e) => setGender(e.target.value)}
              value={gender}
            >
              <option value=''></option>
              <option value='male'>Male</option>
              <option value='female'>Female</option>
              <option value='Prefer not to say'>Prefer not to say</option>
            </select>
          </div> */}
          {/* end::Input group */}

          {/* begin::Input group */}
          {/* <div className='mb-10'>
            <label className='form-label fs-6 fw-bold'>Subscription</label>
            <select
              className='form-select form-select-solid fw-bolder'
              data-kt-select2='true'
              data-placeholder='Select option'
              data-allow-clear='true'
              data-kt-user-table-filter='two-step'
              data-hide-search='true'
              onChange={(e) => setLastLogin(e.target.value)}
              value={lastLogin}
            >
              <option value=''></option>
              <option value='Yesterday'>Yesterday</option>
              <option value='20 mins ago'>20 mins ago</option>
              <option value='5 hours ago'>5 hours ago</option>
              <option value='2 days ago'>2 days ago</option>
            </select>
          </div> */}

          <div>
            <label className='form-label fs-6 fw-bold'>Start date:</label>
            <input
              className='form-select form-select-solid fw-bolder'
              type='date'
              value={sDate}
              max={maxDate}
              onChange={(e) => setSDate(e.target.value)}
            />
          </div>

          <div className='mb-2'>
            <label className='form-label fs-6 fw-bold'>End date:</label>
            <input
              className='form-select form-select-solid fw-bolder'
              type='date'
              value={eDate}
              max={maxDate}
              onChange={(e) => setEDate(e.target.value)}
            />
          </div>

          {/* end::Input group */}

          {/* begin::Actions */}
          <div className='d-flex justify-content-end'>
            <button
              type='button'
              disabled={loading}
              onClick={resetData}
              className='btn btn-light btn-active-light-primary fw-bold me-2 px-6'
              data-kt-menu-dismiss='true'
              data-kt-user-table-filter='reset'
            >
              Reset
            </button>
            {/* <button
              disabled={loading}
              type='button'
              onClick={filterData}
              className='btn btn-primary fw-bold px-6'
              data-kt-menu-dismiss='true'
              data-kt-user-table-filter='filter'
            >
              Apply
            </button> */}
          </div>
          {/* end::Actions */}
        </div>
        {/* end::Content */}
      </div>
      {/* end::SubMenu */}
    </>
  )
}

export {UsersListFilter}
